module.exports = __webpack_public_path__ + "media/images/front/icons/eye-0e18288ce72515e3dfbaab522c7cd64b.svg";